"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vector3 = void 0;
const IsometricUtils_1 = require("./IsometricUtils");
class Vector3 {
    constructor(x = 0, y = 0, z = 0) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
    static from(point, copy = true) {
        if (point instanceof Vector3)
            return copy ? point.clone() : point;
        if (Array.isArray(point))
            return new Vector3(point[0], point[1], point[2]);
    }
    add(point) {
        return new Vector3(this.x + point.x, this.y + point.y, this.z + point.z);
    }
    scale(point) {
        return new Vector3(this.x * point.x, this.y * point.y, this.z * point.z);
    }
    set(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    clone() {
        return new Vector3(this.x, this.y, this.z);
    }
    copyTo(point) {
        return point.set(this.x, this.y, this.z);
    }
    toVector2() {
        return IsometricUtils_1.IsometricUtils.cartToIso(this.x, this.y, this.z);
    }
    equal(point) {
        return this.x === point.x && this.y === point.y && this.z === point.z;
    }
}
exports.Vector3 = Vector3;
